__turbopack_context__.v({
  "arrow": "PillSelect-module__QpFWOq__arrow",
  "disabled": "PillSelect-module__QpFWOq__disabled",
  "label": "PillSelect-module__QpFWOq__label",
  "root": "PillSelect-module__QpFWOq__root",
  "select": "PillSelect-module__QpFWOq__select",
});
